//
// 発注依頼一覧表 スマホで閲覧専用
//
// src/components/orderRequestViewer.js
//


import React, { useEffect, useState } from "react";
import "../styles/orderRequestViewer.css";

function OrderRequestViewer() {
  const [orders, setOrders] = useState([]);
  const [userList, setUserList] = useState([]);
  const [authenticated, setAuthenticated] = useState(false);
  const [password, setPassword] = useState("");

  // 発注依頼データ読み込み ----------------------------------------------------
  useEffect(() => {
    if (!authenticated) return;
    fetch("https://newells4610.stars.ne.jp/data/orderRequestData.json", {
      cache: "no-store",
    })
      .then((res) => res.json())
      .then((data) => {
        // timestamp（登録日時）が新しい順にソート
        const sorted = [...data].sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
        setOrders(sorted);
      })
      .catch(() => setOrders([]));

   // ユーザーデータ読み込み ---------------------------------------------------  
    fetch("https://newells4610.stars.ne.jp/data/userList.json", {
      cache: "no-store",
    })
      .then((res) => res.json())
      .then((data) => setUserList(data))
      .catch(() => setUserList([]));
  }, [authenticated]);

  // 認証チェック
  const handleLogin = () => {
    if (password === "3091107") {
      setAuthenticated(true);
    } else {
      alert("パスワードが違います");
    }
  };

  if (!authenticated) {
    return (
      <div style={{ textAlign: "center", padding: "20px" }}>
        <h3>🔑 発注依頼一覧（閲覧専用）</h3>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="パスワードを入力"
        />
        <button onClick={handleLogin}>OK</button>
      </div>
    );
  }

  return (
    <div className="modal-overlay">
      <div className="modal-box large">
        <h4 className="modal-title">発注依頼一覧（閲覧専用 編集不可）</h4>
        <div className="table-wrapper">
          <table className="viewer-table">
            <thead>
              <tr>
                <th>入荷</th>
                <th>予定日</th>
                <th>発注日</th>
                <th>登録日</th>
                <th>依頼者</th>
                <th>品名</th>
                <th>品番</th>
                <th>注数</th>
                <th>単位</th>
                <th>問屋</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((row, idx) => (
                <tr key={idx}>
                  <td style={{ color: row.inStok === 1 ? "red" : "inherit" }}>
                    {row.inStok === 1 ? "済" : "-"}
                  </td>
                  <td>{row.scheduleDay}</td>
                  <td>{row.orderDay}</td>
                  <td>{new Date(row.timestamp).toLocaleString()}</td>
                  <td>
                    {userList.find((u) => String(u.id) === String(row.userId))
                      ?.name || row.userId}
                  </td>
                  <td>{row.name}</td>
                  <td>{row.productId}</td>
                  <td>{row.orderQuantity}</td>
                  <td>{row.unit}</td>
                  <td>{row.wholesaler}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default OrderRequestViewer;
